<script>
    import MultiEditHeader from '@/components/multi-edit/MultiEditHeader.vue';
    import MultiEditFilter from '@/components/multi-edit/MultiEditFilter.vue';
    import MultiEditTag from '@/components/multi-edit/MultiEditTag.vue';
    import MultiEditText from '@/components/multi-edit/MultiEditText.vue';

    export default {
        components: {
            MultiEditHeader: MultiEditHeader,
            MultiEditFilter: MultiEditFilter,
            MultiEditTag: MultiEditTag,
            MultiEditText: MultiEditText,
        },
        computed: {
            getShowMultiEdit() { return this.$store.getters.IS_SHOW_MULTI_EDIT },
        },
        watch: {
            getShowMultiEdit: {
                handler: async function() { 
                    await this.$store.dispatch('CHECK_ASSET_TYPES');
                }
            }
        }
    }
</script>


<template>
    <div 
        class="left_additional_container"
        v-if="getShowMultiEdit === true"
    >
        <MultiEditHeader />
        <hr class="hr_light_98">
        <MultiEditFilter />
        <hr class="hr_light_98">
        <MultiEditTag />
        <hr class="hr_light_98">
        <MultiEditText />
    </div>
</template>